




import { Component, Model } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Input from './input'
import * as ruleNames from './constants/ruleNames'

@Component
export default class HiddenInput extends mixins(Input) {
  @Model('input', { type: [String, Number] }) value!: string | number

  supportedRules: Array<string> = [
    ruleNames.MIN_LENGTH,
    ruleNames.MAX_LENGTH,
    ruleNames.MIN_VALUE,
    ruleNames.MAX_VALUE,
    ruleNames.BETWEEN,
    ruleNames.BETWEEN_LENGTH,
    ruleNames.REQUIRED,
    ruleNames.ALPHA_NUM,
    ruleNames.INTEGER,
    ruleNames.EMAIL,
    ruleNames.URL,
    ruleNames.HIRAGANA,
    ruleNames.SAME_AS
  ]
}
